<template> 
  <div>    
    <v-list-item-content v-if="!menu.submenu">
      <v-list-item-title>
        <router-link :to="menu.url">{{ menu.titulo }}</router-link>
        <!-- <a :href="menu.url" :target= "menu.link_externo ? '_blank' : ''">
          {{ menu.titulo }}
        </a> -->
      </v-list-item-title>
    </v-list-item-content>

    <template v-if="ehSubmenu && menu.submenu">
      <MenuItemComponent
        v-for="(sub, index) in menu.submenu"
        :key="index"
        :menu="sub"
      ></MenuItemComponent>
    </template>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'MenuItemComponent',
  props: {
    menu: Object,
    selecionado: {
      type: [Object, String]
    },
  },
  data () {
    return {
      menuEstaAberto: false,
      menuSelecionado: ''
    }
  },
  computed: {
    ehSubmenu () {
      return this.menu.submenu && this.menu.submenu.length;
    }
  },
  methods: {
    ...mapActions('menu', ['selecionarMenu']),

    toggle (menu) {    
      if (this.selecionado === menu) {
        this.selecionarMenu('')
        return
      }

      this.selecionarMenu(menu)

      if (this.ehSubmenu) {
        this.menuEstaAberto = !this.menuEstaAberto;   
        this.$emit('emitMenuAberto', this.menu)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.v-list-group__items {
  .v-list-item__content {
    padding: 0;
    margin: 0;
    .v-list-item__title{
      font-size: 15px;
      margin-left: 4px;

      a {
        text-decoration: none;
        display: block;
        padding: 10px 15px;
        width: 100%;
        border-radius: 5px;

        &:hover {
          background-color: #eee;
        }
      }

      a.router-link-active {
        background-color: #f4f4f4;
      }
    }
  }
}
</style>